import React, { Component } from 'react';
import DashUser from '../components/DashUser.js';

class Vendre extends Component {
    render() {
        return (
            <div >
                <DashUser/>
            </div>
        );
    }
}

export default Vendre;
